module.exports = __webpack_public_path__ + "64db5b1527a01cb97d63cc8cfd009970.pdf";